import React, { useEffect, useState } from 'react';
import { useCash } from '../../../../../hooks/useCash';
import { useOffice } from '../../../../../hooks/useOffice';
import { getUser, formatCurrency } from '../../../../../utils/Common';
import Spinner from '../../../../../components/Spinner';

const CurrentBalanceStats = () => {
  const { getCashBoxStatus } = useCash();
  const { getPostOfficeStatus} = useOffice();

  const [valueBalance, setValueBalance] = useState(null);
  const [totalBalance, setTotalBalance] = useState(0);
  const [saldoEstafeta, setSaldoEstafeta] = useState(null);

  const user = getUser();


  const handleGetStatsUser = async () => {
      const abortController = new AbortController();
      const response = await getCashBoxStatus(abortController.signal);
      if (response?.cajas?.length > 0) {
        const newBalances = response.cajas[0].SaldoCaja ?? 0;
        const total = response.totalCajas ?? 0;
        setValueBalance(newBalances);
        setTotalBalance(total);
      }
  };

  const handleGetInfoOffices = async () => {
    const abortController = new AbortController();
    const response = await getPostOfficeStatus(abortController.signal);
    if (response?.payload?.length > 0) {
      const saldoTotal = response.payload.reduce(
        (acc, sucursal) => acc + (sucursal.SaldoSucursal || 0),
        0
      );
      setSaldoEstafeta(saldoTotal);
    }
  };

  const BalanceCard = ({ label, value, isLoading, color = "#0eab9b", bg = "#dbf5f3" }) => (
  <div
    className="text-center mt-lg-0 mt-sm-3"
    style={{
      fontSize: "1rem",
      background: bg,
      padding: "8px 12px",
      borderRadius: "12px",
    }}
  >
    <div style={{ color }}>{label}</div>
    {isLoading ? (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 5,
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <Spinner type={0} size={10} color={color} />
        <Spinner type={0} size={10} color={color} />
        <Spinner type={0} size={10} color={color} />
      </div>
    ) : (
      <div className="text-bold" style={{ color }}>
        {value}
      </div>
    )}
  </div>
  );

  useEffect(() => {

    handleGetStatsUser();
    handleGetInfoOffices();
  }, []);

  return (
    <div className="d-flex justify-content-start gap-3 mt-1" style={{ gap: 10 }}>
      {user.roleId >= 2 && (
        <BalanceCard
          label={[2,3].includes(user.roleId) ? "Saldo de estafeta" : "Saldo de estafetas"}
          isLoading={saldoEstafeta === null}
          value={formatCurrency(saldoEstafeta !== 0 ? saldoEstafeta : 0)}
        />
      )}
        <BalanceCard
          label={`Saldo ${totalBalance ? "en operación" : "actual"}`}
          isLoading={valueBalance === null}
          value={formatCurrency(
            totalBalance !== null && totalBalance !== undefined && totalBalance !== 0
              ? totalBalance
              : valueBalance !== null && valueBalance !== undefined && valueBalance !== 0
                ? valueBalance
                : 0
          )}
        />

    </div>
  );
};

export default CurrentBalanceStats;